// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".booking-tool-section[data-v-34f13686]{display:flex;justify-content:center;padding-bottom:60px;padding-top:4rem}@media (min-width:768px){.booking-tool-section[data-v-34f13686]{padding-bottom:80px}}.booking-tool-btn[data-v-34f13686]{font-size:15px;min-height:52px;padding:1.5rem 4rem}@media (min-width:768px){.booking-tool-btn[data-v-34f13686]{min-height:48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
